import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoWhite from '../assets/entrecor_logo_blanco.png';
import logoColor from '../assets/entrecor_logo_color.png';

const links = [
  ['/#quienes-somos', 'Quiénes somos'],
  ['/#productos', 'Productos'],
  ['/sectores/proceso_productivo', 'Sectores'],
  ['/#contacto', 'Contacto'],
  ['/#ubicacion', 'Ubicación'],
];

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);
  const toggleRef = useRef(null);
  const isSector = location.pathname.startsWith('/sectores');

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    const observer = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--nav-height', `${navRef.current.offsetHeight}px`);
    });
    observer.observe(navRef.current);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  useEffect(() => setIsOpen(false), [location]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
        toggleRef.current?.focus();
      }
    };
    const onPointer = (event) => {
      if (!navRef.current?.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onPointer);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onPointer);
    };
  }, [isOpen]);

  return (
    <nav ref={navRef} id="main-navbar" data-main-nav="true" aria-label="Navegación principal"
      className={`fixed top-0 left-0 w-full px-5 py-4 lg:px-8 flex items-center justify-between gap-8 z-40 transition-colors duration-300 ${isSector ? 'bg-white text-[#3A3A3C] shadow-sm' : scrolled || isOpen ? 'bg-black text-white' : 'bg-transparent text-white'}`}>
      <Link to="/" aria-label="Entrecor — Inicio" className="block w-36 lg:w-44 shrink-0" onClick={() => setIsOpen(false)}>
        <img src={isSector ? logoColor : logoWhite} alt="Entrecor" className="w-full" />
      </Link>
      <button ref={toggleRef} type="button" onClick={() => setIsOpen(open => !open)}
        className="lg:hidden flex items-center justify-center w-11 h-11 rounded-lg hover:bg-gray-400/15"
        aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} aria-controls="main-menu">
        <svg aria-hidden="true" className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
        </svg>
      </button>
      <ul id="main-menu" className={`${isOpen ? 'flex animate-fade-up' : 'hidden'} lg:flex flex-col lg:flex-row lg:items-center lg:mx-auto gap-1 lg:gap-6 xl:gap-12 absolute lg:static top-full left-0 w-full lg:w-auto bg-black/95 text-white lg:bg-transparent lg:text-inherit p-5 lg:p-0 shadow-lg lg:shadow-none max-h-[calc(100svh-var(--nav-height))] overflow-y-auto`}>
        {links.map(([to, label]) => (
          <li key={to}>
            <Link to={to} onClick={() => setIsOpen(false)}
              aria-current={to.startsWith('/sectores') && isSector ? 'page' : location.pathname + location.hash === to ? 'location' : undefined}
              className="block py-3 lg:py-2 font-noto cursor-pointer select-none transition-colors hover:text-[#B89A6E]">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Navbar;
